// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/152ae111311d25ce5c95.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ba4a3cc7e58b15e66b6b","136":"56466ecfc2e228721cce","137":"da4d3615f659599cb9a2"}[chunkId] + ".chunk.js";
};